import React, { useMemo }  from 'react';
import { useEffect } from 'react';

//import NextLink from 'next/link';
import { NavLink, 
        Link,  
        useParams,
        useLocation,
        useHistory,
        useRouteMatch, } from 'react-router-dom';
import queryString from "query-string";
import PropTypes from 'prop-types';
import { Box, Button, Divider, Drawer, Typography, useMediaQuery } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Image } from 'semantic-ui-react';
import { ChartBar as ChartBarIcon } from '../../icons/ChartBar';
import { Cog as CogIcon } from '../../icons/Cog';
import { Lock as LockIcon } from '../../icons/Lock';
import { Selector as SelectorIcon } from '../../icons/Selector';
import { ShoppingBag as ShoppingBagIcon } from '../../icons/ShoppingBag';
import { User as UserIcon } from '../../icons/User';
import { UserAdd as UserAddIcon } from '../../icons/UserAdd';
import { Users as UsersIcon } from '../../icons/Users';
import { XCircle as XCircleIcon } from '../../icons/XCircle';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import AppShortcutIcon from '@mui/icons-material/AppShortcut';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BusinessIcon from '@mui/icons-material/Business';
import StoreIcon from '@mui/icons-material/Store';
import MapIcon from '@mui/icons-material/Map';
import CommentIcon from '@mui/icons-material/Comment';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { db } from '../../firebase';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import useGlobalConfig from '../../hooks/globalConfig';
export const DashboardSidebarCliente = (props) => {
 // console.log(props.patuserRol)
 const {img5} = useGlobalConfig()
  var actualUserRoll = props.patuserRol
  
  //declaracion de servicios
  // const servicios ={
  //   toPath:"/dashboard/tablero",
  //   nameLink:'Esconder Link',
  //   servID:'public',
  //   icon:'ChatBatIcon'
  // }        
  // const servDashboard ={
  //   toPath:"/dashboard/tablero",
  //   nameLink:'TEST LINK',
  //   servID:'public',
  //   icon:<ChartBarIcon fontSize="medium" />
  // } 
  // // Servicio 001 Tablero Metricas
  // const serv001 ={
  //   toPath:"/dashboard/tablero",
  //   nameLink:'Dashboard',
  //   servID:'serv01',
  //   icon:<ChartBarIcon fontSize="medium" />
  // } 
  // // Servicio 002 envío Express
  // const serv002 ={
  //   toPath:"/dashboard/envios-express",
  //   nameLink:'envío Express',
  //   servID:'serv02',
  //   icon:<ListAltIcon fontSize="medium" />
  // } 
  // // Servicio 003 Mi cuenta
  // const serv003 ={
  //   toPath:"/dashboard/mi-cuenta",
  //   nameLink:'Mi Cuenta',
  //   servID:'serv03',
  //   icon:<UserIcon fontSize="medium" />
  // } 
  // // Servicio 004 Mis Direccciones
  // const serv004 ={
  //   toPath:"/dashboard/direcciones",
  //   nameLink:'Direcciones',
  //   servID:'serv04',
  //   icon:<AddLocationAltIcon fontSize="medium" />
  // } 
  // // Servicio serv05  Mis Mapas
  // const serv05 ={
  //   toPath:"/dashboard/maps",
  //   nameLink:'Mapas',
  //   servID:'serv05',
  //   icon:<MapIcon fontSize="medium" />
  // }
  // // Servicio serv06 Send Bugs
  // const serv06 ={
  //   toPath:"/dashboard/report-bugs",
  //   nameLink:'Reportar Error',
  //   servID:'serv06',
  //   icon:<XCircleIcon fontSize="medium" />
  // }
  // // Servicio serv07 Send Mensaje
  // const serv07 ={
  // toPath:"/dashboard/mensaje",
  // nameLink:'Mensajes',
  // servID:'serv07',
  // icon:<CommentIcon fontSize="medium" />
  // }
  // // Servicio serv08 Send Soporte
  // const serv08 ={
  // toPath:"/dashboard/soporte",
  // nameLink:'Soporte',
  // servID:'serv08',
  // icon:<AnnouncementIcon fontSize="medium" />
  // }
  // // Servicio serv09 Empresas
  // const serv09 ={
  // toPath:"/dashboard/companies",
  // nameLink:'Empresa',
  // servID:'serv09',
  // icon:<BusinessIcon fontSize="medium" />
  // } 
  // // Servicio serv10 Stores
  // const serv10 ={
  // toPath:"/dashboard/stores",
  // nameLink:'Sucursales',
  // servID:'serv10',
  // icon:<StoreIcon fontSize="medium" />
  // } 
  // // Servicio serv11 Usuarios
  // const serv11 ={
  //   toPath:"/dashboard/usuarios",
  //   nameLink:'Agregar usuario',
  //   servID:'serv11',
  //   icon:<UserAddIcon fontSize="medium" />
  // } 
  // // Servicio serv12 Administradores
  // const serv12 ={
  //   toPath:"dashboard/administrators",
  //   nameLink:'Administradores',
  //   servID:'serv12',
  //   icon:<UsersIcon fontSize="medium" />
  // }
  // // Servicio serv13 Administradores
  // const serv13 ={
  //   toPath:"/dashboard/users",
  //   nameLink:'Usuaros Empresa',
  //   servID:'serv13',
  //   icon:<UsersIcon fontSize="medium" />
  // }
  // // Servicio serv14 Crear Despachos  
  // const serv14 ={
  //   toPath:"/dashboard/creartedispatch",
  //   nameLink:'Crear Despachos',
  //   servID:'serv14',
  //   icon:<ContentPasteGoIcon fontSize="medium" />
  // }
  // // Servicio serv15 Manejar Ordenes  
  // const serv15 ={
  //   toPath:"/dashboard/dispatch",
  //   nameLink:'Despachos',
  //   servID:'serv15',
  //   icon:<LocalShippingIcon fontSize="medium" />
  // }
  // // Servicio serv16 Manejar Ordenes
  // const serv16 ={
  //   toPath:"/dashboard/ebiex-drivers",
  //   nameLink:'Ebiex Drivers',
  //   servID:'serv16',
  //   icon:<DirectionsBikeIcon fontSize="medium" />
  // }
  // // Servicio serv17 Manejar Ordenes
  // const serv17 ={
  //   toPath:"/dashboard/guides",
  //   nameLink:'Guias',
  //   servID:'serv17',
  //   icon:<ContentPasteGoIcon fontSize="medium" />
  // }
  // // Servicio serv18 Manejar Rutas
  // const serv18 ={
  //   toPath:"/dashboard/routes",
  //   nameLink:'Rutas',
  //   servID:'serv18',
  //   icon:<ContentPasteGoIcon fontSize="medium" />
  // }
  // // Servicio serv19 Maps
  // const serv19 ={
  // toPath:"/dashboard/maps",
  // nameLink:'Mapa',
  // servID:'serv19',
  // icon:<MapIcon fontSize="medium" />
  // }
  // // Servicio serv20 Manager Servicies
  // const serv20 ={
  //   toPath:"/dashboard/servicios",
  //   nameLink:'Servicios',
  //   servID:'serv20',
  //   icon:<AppShortcutIcon fontSize="medium" />
  // }
  // // Servicio serv21 Manager Settings
  // const serv21 ={
  // toPath:"/dashboard/settings",
  //  nameLink:'Configuraciones',
  //  servID:'serv21',
  //  icon:<CogIcon fontSize="medium" />
  // }
  // // Servicio serv22 Manager Settings
  // const serv22 ={
  //  toPath:"/dashboard/Seguridad",
  //  nameLink:'Seguridad',
  //  servID:'serv22',
  //  icon:<LockIcon fontSize="medium" />
  // }
  // // Servicio serv23 Manager Bugs 
  // const serv23 ={
  // toPath:"/dashboard/manager-bug",
  // nameLink:'Informes de Error',
  // servID:'serv23',
  // icon:<XCircleIcon fontSize="medium" />
  // }

  // // Servicio serv24 Manager Bugs 
  // const serv24 ={
  // toPath:"/dashboard/manager-mensajes",
  // nameLink:'Mensjaes',
  // servID:'serv24',
  // icon:<CommentIcon fontSize="medium" />
  // }

  // // Servicio serv25 Manager Soporte
  // const serv25 ={
  // toPath:"/dashboard/manager-soporte",
  // nameLink:'Mensjaes',
  // servID:'serv25',
  // icon:<CommentIcon fontSize="medium" />
  // }


  const BlockVista = ({servicios}) => {  
    const[serviceState,setSetvice] = React.useState('')
    const[serviceActive,setSetviceActive] = React.useState('')


    const checkDisplay = async (actualUserRoll) =>{
     // Esconder link segun roll
      try {
        const servicio = await db.collection(`${process.env.REACT_APP_COL_ROLES}`)
        .doc(actualUserRoll)
        .get();
        if(servicio.data()){ 
        //  console.log('AQUI ROL')
          servicios.permisos = servicio.data()[servicios.servID];
        //  console.log(servicios.permisos)
          setSetvice(servicios.permisos)
        }
        //setUserPermissions(servicio.data()[id])
      } catch (error) {
       
      }
    // Esconder link Estado de servicio
      try {
        const servicioState = await db.collection('codeservices')
        .doc(servicios.servID)
        .get();
        if(servicioState.data()){ 
       //  console.log('AQUI ESTADO')
         servicios.state = servicioState.data()['active'];
       //  console.log(servicios.state)
         setSetviceActive(servicios.state)
       }
      //setUserPermissions(servicio.data()[id])
      } catch (error) {  
      }
    }
    checkDisplay(actualUserRoll)
 //   console.log(serviceState)
 //   console.log(servicios.permisos)
    if((serviceState === true)&&(serviceActive === true) ){
      return  <NavLink to={servicios.toPath} className="btn-sidebarLink">
      <div className='btn btn-lg btn-block btn-sidebar'>{servicios.icon}<span className='btn-title'>{servicios.nameLink}</span></div>
      </NavLink>

  

      }else{
        return  ""
      }
  }

  return (

    <div className="sidebar-body">
         <div id="brandsLogo">
         <Image className="brands brands-dash" src={img5} />
         </div>
         <hr className='sidebar-hr'></hr>

    
    <hr></hr>

    <NavLink to="/dashboard/tablero" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><ListAltIcon fontSize="medium" /><span className='btn-title'>Actividad</span></div>
    </NavLink> 

    <hr></hr>
    
    <NavLink to="/dashboard/mi-cuenta" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><UserIcon fontSize="medium" /><span className='btn-title'>Mi Cuenta</span></div>
    </NavLink> 


    <hr></hr>

    <NavLink to="/dashboard/direcciones" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><AddLocationAltIcon fontSize="medium" /><span className='btn-title'>Direcciones</span></div>
    </NavLink>

    <hr></hr>


    <NavLink to="/dashboard/envios-express" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><DeliveryDiningIcon fontSize="medium" /><span className='btn-title'>Envío Express</span></div>
    </NavLink> 

    <hr></hr>

    <NavLink to="/dashboard/maps" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><MapIcon fontSize="medium" /><span className='btn-title'>Mapas</span></div>
    </NavLink>

    <hr></hr>




     {/* <NavLink to="/dashboard/usuarios" className="btn-sidebarLink" >
    <div className='btn btn-lg btn-block btn-sidebar'><UserAddIcon fontSize="medium" /><span className='btn-title'>Agregar Usuario</span></div>
    </NavLink>  */}

    <hr className='sidebar-hr'></hr>

    <NavLink to="/dashboard/companies" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><BusinessIcon fontSize="medium" /><span className='btn-title'>Empresa</span></div>
    </NavLink>

    <hr ></hr>

    
    {/* <NavLink to="/dashboard/stores" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><StoreIcon fontSize="medium" /><span className='btn-title'>Sucursales</span></div>
    </NavLink> */}

    <hr ></hr>

    {/* <NavLink to="/dashboard/administrators" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><UsersIcon fontSize="medium" /><span className='btn-title'>Administradores</span></div>
    </NavLink> */}

    <hr ></hr>

    {/* <NavLink to="/dashboard/users" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><UsersIcon fontSize="medium" /><span className='btn-title'>Usuarios</span></div>
    </NavLink> */}


    <hr className='sidebar-hr'></hr>



    {/* <NavLink to="/dashboard/ebiex-drivers" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><DirectionsBikeIcon fontSize="medium" /><span className='btn-title'>Conductores</span></div>
    </NavLink> */}


    <hr></hr>


    <NavLink to="/dashboard/dispatch" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><LocalShippingIcon fontSize="medium" /><span className='btn-title'>Desapachos</span></div>
    </NavLink>

    <hr></hr>

    {/* <NavLink to="/dashboard/guides" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><ContentPasteGoIcon fontSize="medium" /><span className='btn-title'>Guias</span></div>
    </NavLink> */}


    <hr></hr>

    {/* <NavLink to="/dashboard/routes" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><ForkLeftIcon fontSize="medium" /><span className='btn-title'>Rutas</span></div>
    </NavLink> */}


    <hr className='sidebar-hr'></hr>

    <NavLink to="/dashboard/servicios" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><AppShortcutIcon fontSize="medium" /><span className='btn-title'>Servicios</span></div>
    </NavLink> 
    <hr></hr>

    {/* <NavLink to="/dashboard/settings" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><CogIcon fontSize="medium" /><span className='btn-title'>Configuraciones</span></div>
    </NavLink> */}

    {/* <hr></hr>
    <NavLink to="/dashboard/Seguridad" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><LockIcon fontSize="medium" /><span className='btn-title'>Seguridad</span></div>
    </NavLink> */}
   {/* <NavLink to="/dashboard/soporte" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><SupportIcon fontSize="medium" /><span className='btn-title'>Soporte</span></div>
    </NavLink> */}

  
    <hr></hr>

    <NavLink to="/dashboard/report-bugs" className="btn-sidebarLink">
    <div className='btn btn-lg btn-block btn-sidebar'><XCircleIcon fontSize="medium" /><span className='btn-title'>Reportar error</span></div>
    </NavLink>

    <hr className='sidebar-hr'></hr>
    <Box
          sx={{
            px: 2,
            py: 3
          }}
        >
          <Typography
            color="neutral.100"
            variant="subtitle2"
          >
            Necesitas más Soluciones?
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            Consulta con nuestro equipo de integraciones.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              mt: 2,
              mx: 'auto',
              width: '160px',
              '& img': {
                width: '100%'
              }
            }}
          >
            <img
              alt="Go to pro"
              src="/static/images/sidebar_pro.png"
            />
          </Box>
          <NavLink
            to="/contacto"
                      >
            <Button
              color="secondary"
              endIcon={(<OpenInNewIcon />)}
              fullWidth
              sx={{ mt: 2 }}
              variant="contained"
            >
              Contactanos
            </Button>
          </NavLink>
        </Box>
    </div>
  );
};

